import React, { useContext, useState, useEffect } from "react";
import { pServer, pCommProviderSelection, pDataProvider, pDataTypeVideo } from "../utils/parameters";
import { firebase_auth, firebase_db, googleProvider } from "./utils/firebase";
import { apiRest_pingServer, apiRest_getJSONDataUser, apiRest_getJSONWebInfo, apiRest_getJSONData, comm_getVideoData, apiRest_updateTheme, apiRest_updateLang, apiRest_updateSession, 
         apiRest_addFavorites, apiRest_removeFavorites,
         apiRest_addHistory, apiRest_getHistory, apiRest_removeHistory, apiRest_createReportBug, apiRest_getReportBug, apiRest_sendVideo, apiRest_sendMediapipe, apiRest_updateFeedback, 
         apiRest_sendCollaboration, apiRest_getDatasetBuilder, apiRest_getVideoDatasetBuilder, apiRest_sendDatasetBuilder, apiRest_getRecords, apiRest_removeRecord, apiRest_revertRemoveRecord, apiRest_getVideoData, 
         apiRest_updateProfile, apiRest_updateDefaultPermission, apiRest_updateEmailPermission, apiRest_getDonateSign, apiRest_sendDonateSign, apiRest_updateDefaultCamera,  
         apiRest_getDataVersusMachine, apiRest_sendDataVersusMachine, apiRest_getDataVersusMachine2, apiRest_sendDataVersusMachine2, apiRest_getReportUserActivity,
         apiRest_getDataMoveYourSkeleton, apiRest_sendResultsMoveYourSkeleton, apiRest_sendVideoMoveYourSkeleton,
         apiRest_createTeam, apiRest_getInfoTeam, apiRest_removeTeam, apiRest_updateTeam, apiRest_updateRecord, apiRest_getReportTeamActivity,
         apiRest_acceptInvitationMemberTeam, apiRest_requestInvitationMemberTeam, apiRest_getInfoMemberTeam, apiRest_cancelInvitationMemberTeam,
         apiRest_getRankDataTeam, apiRest_createTaskTeam, apiRest_getTaskTeam, apiRest_updateTaskTeam, apiRest_removeTaskTeam, apiRest_sendSubmission, apiRest_getLeaderboard,
         apiRest_getReportActivity, apiRest_sendMediapipeFastMode, apiRest_donateSentence, apiRest_donateResponse, apiRest_sendResponseSurvey,
         apiRest_sendVideoFS, apiRest_getDonateFingerspelling, apiRest_sendDonateFingerspelling, apiRest_getDonateSentence, apiRest_getDonateResponse,
         apiRest_getDatasetBuilderSentence, apiRest_sendDatasetBuilderSentence, apiRest_deleteDatasetBuilderSentence
        } from "./wrapper/RESTful";
import { firebase_login, firebase_signup, firebase_logout, firebase_resetPassword, firebase_guestLogin, firebase_login_google_provider } from "./wrapper/Firebase";
import { firebase_getJSONWebInfo, firebase_download_JSON } from "./wrapper/Firebase";
import axios from "axios";

const CommProviderContext = React.createContext();

export function useCommProvider() {
    return useContext(CommProviderContext);
}

export function CommProvider({ children }) {

    const [ commProviderSelected, setCommProviderSelected ] = useState(pCommProviderSelection.SERVER);
    const [ base_url, setBase_url ] = useState(pServer.server_url);
    const [ base_url_data, setBase_url_data ] = useState(pServer.server_url_data);

    function comm_configure_base_url(commProviderSelectedIdx){

        setCommProviderSelected(commProviderSelectedIdx)
        if (commProviderSelectedIdx === pCommProviderSelection.SERVER) {
            setBase_url(pServer.server_url)
            setBase_url_data(pServer.server_url_data)
        } else if (commProviderSelectedIdx === pCommProviderSelection.SERVER_BACKUP) {
            setBase_url(pServer.server_backup_url)
            setBase_url_data(pServer.server_backup_url_data)
        }
    }

    // INIT - CREATE LISTENER & LOAD DATA.
    function comm_activateListenerUserAuth(setCurrentUser, setToken_id, serviceStatus, setServiceStatus) {
        const unsubscribe_auth = firebase_auth.onAuthStateChanged((user) => {
            if (user!==undefined && user!==null) {
                setCurrentUser(user);
                
                user.getIdToken().then((token_id) => {
                    setToken_id(token_id);
                    setServiceStatus({...serviceStatus, user: false})
                });
            }
        });
        return unsubscribe_auth
    }

    async function comm_updateUserTokenAuth(currentUser, setToken_id) {
        setToken_id(await currentUser.getIdToken(true))
    }


    // WEB INFO : REQUEST TO FIREBASE.
    async function comm_getJSONWebInfo() {
        try{
            const response = await firebase_getJSONWebInfo(firebase_db)
            return response
        }catch(e){
            console.error("[FIREBASE - ERROR]", e)
            throw Error ('[comm_getJSONWebInfo] It is not possible connect to server.')
        }
    }

    // JSON DATA : DOWNLOAD FROM FIREBASE.
    async function comm_getJSONData(json_file) {
            try{
                const url_json_file = base_url_data + '/' +json_file
                const response = await axios.get(url_json_file, { responseType: 'json' });
                return response.data
            }catch(e){
                console.error("[ERROR] 🚀 ~ file: CommProvider.js:121 ~ comm_getJSONData ~ error", e)
                throw Error ('[comm_getJSONData] It is not possible connect to server.')
            }
    }

    async function comm_downloadFileFromUrl(url_file) {
        try{
            const response = await axios.get(url_file, { responseType: 'json' });
            return response.data
        }catch(e){
            console.error("[FIREBASE - ERROR] 🚀 ~ file: CommProvider.js:121 ~ comm_getJSONData ~ error", e)
            throw Error ('[comm_getJSONData] It is not possible connect to server.')
        }
    }

    // Download personal information from user. - PENDIENTE ALTERNATIVA - FIREBASE OFF.
    async function comm_getJSONDataUser(token_id, currentUser) {
            try{
                const response = await apiRest_getJSONDataUser(token_id, currentUser.uid, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:89 ~ comm_getJSONDataUser ~ error", e)
            }
    }

    async function comm_getVideoData(token_id, currentUser, video_origin, video_filename, type=pDataTypeVideo.video_RGB){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getVideoData(token_id, currentUser.uid, video_origin, video_filename, type, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:140 ~ comm_getVideoData ~ error", e)
                    throw Error ('[comm_getVideoData] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendVideo(token_id, currentUser, videoFile) {
            try{
                const response = await apiRest_sendVideo(token_id, currentUser.uid, videoFile, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:142 ~ comm_sendVideo ~ error", e)
                throw Error ('[comm_sendVideo] It is not possible connect to server.')
            }
    }
    
    async function comm_sendMediapipe(token_id, currentUser, video, mediapipe) {
            try{
                const response = await apiRest_sendMediapipe(token_id, currentUser.uid, video, mediapipe, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:142 ~ comm_sendMediapipe ~ error", e)
                throw Error ('[comm_sendMediapipe] It is not possible connect to server.')
            }
    }

    async function comm_sendMediapipeFastMode(token_id, currentUser, mediapipe) {
        try{
            const response = await apiRest_sendMediapipeFastMode(token_id, currentUser.uid, mediapipe, base_url)
            return response
        }catch(e){
            console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:142 ~ comm_sendMediapipeFastMode ~ error", e)
            throw Error ('[comm_sendMediapipeFastMode] It is not possible connect to server.')
        }
    }

    async function comm_sendVideoFS(token_id, currentUser, videoFile) {
        try{
            const response = await apiRest_sendVideoFS(token_id, currentUser.uid, videoFile, base_url)
            return response
        }catch(e){
            console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:142 ~ comm_sendVideoFS ~ error", e)
            throw Error ('[comm_sendVideoFS] It is not possible connect to server.')
        }
}

    async function commm_updateFeedback(token_id, currentUser, video_id, data, data_labels) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateFeedback(token_id, currentUser.uid, video_id, data, data_labels, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:174 ~ commm_updateFeedback ~ error", e)
                    throw Error ('[commm_updateFeedback] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendCollaboration(token_id, currentUser, data, data_labels, f, team_id = '', task_id = '') {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendCollaboration(token_id, currentUser.uid, data, data_labels, f, team_id, task_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_sendCollaboration ~ error", e)
                    throw Error ('[comm_sendCollaboration] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDonateFingerspelling(token_id, currentUser) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDonateFingerspelling(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_sendDonateFingerspelling ~ error", e)
                    throw Error ('[comm_sendDonateFingerspelling] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendDonateFingerspelling(token_id, currentUser, feedback_lemma_fs_label, f, team_id = '', task_id = '') {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDonateFingerspelling(token_id, currentUser.uid, feedback_lemma_fs_label, f, team_id, task_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_sendDonateFingerspelling ~ error", e)
                    throw Error ('[comm_sendDonateFingerspelling] It is not possible connect to server.')
                }
        }
    }

    


    async function comm_donateSentence(token_id, currentUser, f, data) {
        console.log("🚀 ~ comm_donateSentence ~ comm_donateSentence:", comm_donateSentence)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_donateSentence(token_id, currentUser.uid, f, data, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_donateSentence ~ error", e)
                    throw Error ('[comm_donateSentence] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDonateSentence(token_id, currentUser) {
        console.log("🚀 ~ comm_donateSentence ~ comm_donateSentence:", comm_donateSentence)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDonateSentence(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_donateSentence ~ error", e)
                    throw Error ('[comm_donateSentence] It is not possible connect to server.')
                }
        }
    }


    async function comm_donateResponse(token_id, currentUser, f, data) {
        console.log("🚀 ~ comm_donateResponse ~ comm_donateResponse:", comm_donateResponse)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_donateResponse(token_id, currentUser.uid, f, data, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_donateResponse ~ error", e)
                    throw Error ('[comm_donateResponse] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDonateResponse(token_id, currentUser) {
        console.log("🚀 ~ comm_donateResponse ~ comm_donateResponse:", comm_donateResponse)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDonateResponse(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_donateResponse ~ error", e)
                    throw Error ('[comm_donateResponse] It is not possible connect to server.')
                }
        }
    }


    async function comm_sendSubmission(token_id, currentUser, type, submission_reference, submission_data, f) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendSubmission(token_id, currentUser.uid, type, submission_reference, submission_data, f, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:170 ~ apiRest_sendSubmission ~ error", e)
                    throw Error ('[apiRest_sendSubmission   ] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDatasetBuilder(token_id, currentUser, session, annotation_idx){
        console.log("🚀 ~ file: CommProvider.js:182 ~ comm_requestVideoDatasetBuilder ~ session", session)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDatasetBuilder(token_id, currentUser.uid, session, annotation_idx, base_url)

                    console.log('COM_REQUEST_VIDEO_DATASET_BUILDER - RESPONSE: ', response)

                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:189 ~ comm_requestVideoDatasetBuilder ~ error", e)
                    throw Error ('[comm_requestVideoDatasetBuilder] It is not possible connect to server.')
                }
        }
    }

    async function comm_requestVideoDatasetBuilder(token_id, currentUser, session, f){
        console.log("🚀 ~ file: CommProvider.js:182 ~ comm_requestVideoDatasetBuilder ~ session", session)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getVideoDatasetBuilder(token_id, currentUser.uid, session, f, base_url)

                    console.log('COM_REQUEST_VIDEO_DATASET_BUILDER - RESPONSE: ', response)

                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:189 ~ comm_requestVideoDatasetBuilder ~ error", e)
                    throw Error ('[comm_requestVideoDatasetBuilder] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendDatasetBuilder(token_id, currentUser, session, filename, class_id, annotation_code_id, comment, counter_repeats_used, history_log, edit_annotation_idx){
        console.log("🚀 ~ file: CommProvider.js:182 ~ comm_sendDatasetBuilder ~ session", session)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDatasetBuilder(token_id, currentUser.uid, session, filename, class_id, annotation_code_id, comment, counter_repeats_used, history_log, edit_annotation_idx, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:203 ~ comm_sendDatasetBuilder ~ error", e)
                    throw Error ('[comm_sendDatasetBuilder] It is not possible connect to server.')
                }
        }
    }


    async function comm_getDatasetBuilderSentence(token_id, currentUser, scope, origin, record_id, filter_by_previous){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDatasetBuilderSentence(token_id, currentUser.uid, scope, origin, record_id, filter_by_previous, base_url)

                    console.log('COM_REQUEST_VIDEO_DATASET_BUILDER - RESPONSE: ', response)

                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:333 ~ apiRest_getDatasetBuilderSentence ~ error", e)
                    throw Error ('[apiRest_getDatasetBuilderSentence] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendDatasetBuilderSentence(token_id, currentUser, data_annotation){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDatasetBuilderSentence(token_id, currentUser.uid, data_annotation, base_url)

                    console.log('COM_REQUEST_VIDEO_DATASET_BUILDER - RESPONSE: ', response)

                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:349 ~ comm_sendDatasetBuilderSentence ~ error", e)
                    throw Error ('[comm_sendDatasetBuilderSentence] It is not possible connect to server.')
                }
        }
    }


    async function comm_deleteDatasetBuilderSentence(token_id, currentUser, origin, record_id, annotation_timestamp){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_deleteDatasetBuilderSentence(token_id, currentUser.uid, origin, record_id, annotation_timestamp, base_url)

                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:362 ~ comm_deleteDatasetBuilderSentence ~ error", e)
                    throw Error ('[comm_deleteDatasetBuilderSentence] It is not possible connect to server.')
                }
        }
    }













    async function comm_getDonateSign(token_id, currentUser) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDonateSign(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ apiRest_getDonateSign ~ error", e)
                    throw Error ('[comm_sendCollaboration] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendDonateSign(token_id, currentUser, data, data_labels, f) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDonateSign(token_id, currentUser.uid, data, data_labels, f, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ apiRest_sendDonateSign ~ error", e)
                    throw Error ('[comm_sendCollaboration] It is not possible connect to server.')
                }
        }
    }

    async function comm_createReportBug(token_id, currentUser, data){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_createReportBug(token_id, currentUser.uid, data, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:227 ~ comm_createReportBug ~ error", e)
                    throw Error ('[comm_createReportBug] It is not possible connect to obtain this data.')
                }
        }
    }

    async function comm_getReportBug(token_id, currentUser, owner_id=currentUser.uid, query='ALL'){   // Default owner_id (issues created by the currentUser) & query ALL (open & closed issues)
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getReportBug(token_id, currentUser.uid, owner_id, query, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:242 ~ comm_getReportBug ~ error", e)
                    throw Error ('[comm_getReportBug] It is not possible connect to obtain this data.')
                }
        }
    }

    async function comm_updateReportBug(){
        throw Error ('[comm_updateReportBug] Not implemented yet.')
    }

    async function comm_closeReportBug(){
        throw Error ('[comm_closeReportBug] Not implemented yet.')
    }
    

    // async function comm_create_User(){
    //     throw Error ('[comm_create_User] Not implemented yet.')
    // }
    async function comm_updateProfile(token_id, currentUser, changedFields){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateProfile(token_id, currentUser.uid, changedFields, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:294 ~ comm_addFavorites ~ error", e)
                    throw Error ('[comm_addFavorites] It is not possible connect to server.')
                }
        }
    }


    async function comm_updateTheme(token_id, currentUser, sw){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateTheme(token_id, currentUser.uid, sw, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:113 ~ comm_updateTheme ~ error", e)
                }
        }
    }

    async function comm_updateLang(token_id, currentUser, sw){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateLang(token_id, currentUser.uid, sw, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:113 ~ apiRest_updateLang ~ error", e)
                }
        }
    }

    async function comm_updateSession(token_id, currentUser, data){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateSession(token_id, currentUser.uid, data, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:113 ~ comm_updateSession ~ error", e)
                }
        }
    }

    async function comm_addFavorites(token_id, currentUser, sign_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_addFavorites(token_id, currentUser.uid, sign_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:294 ~ comm_addFavorites ~ error", e)
                    throw Error ('[comm_addFavorites] It is not possible connect to server.')
                }
        }
    }

    async function comm_removeFavorites(token_id, currentUser, sign_id){

        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_removeFavorites(token_id, currentUser.uid, sign_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:310 ~ comm_removeFavorites ~ error", e)
                    throw Error ('[comm_removeFavorites] It is not possible connect to server.')
                }
        }
    }


    async function comm_getHistory(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getHistory(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:354 ~ comm_getHistory ~ error", e)
                    throw Error ('[comm_getHistory] It is not possible connect to server.')
                }
        }
    }


    async function comm_addHistory(token_id, currentUser, lemma_id, date){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_addHistory(token_id, currentUser.uid, lemma_id, date, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:370 ~ comm_addHistory ~ error", e)
                    throw Error ('[comm_addHistory] It is not possible connect to server.')
                }
        }
    }


    async function comm_removeHistory(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_removeHistory(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:386 ~ comm_removeHistory ~ error", e)
                    throw Error ('[comm_addHistory] It is not possible connect to server.')
                }
        }
    }

    async function comm_getRecords(token_id, currentUser, type, split_id=null, team_id=null, target_user_id=null){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    let response = await apiRest_getRecords(token_id, currentUser.uid, type, split_id, team_id, target_user_id, base_url)
                    response.forEach((record) => {
                        record.id = record._id;
                    });
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:344 ~ comm_getRecords ~ error", e)
                    throw Error ('[comm_getRecords] It is not possible connect to server.')
                }
        }
    }

    async function updateFeedbackRecord(token_id, currentUser, record_id, data){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateRecord(token_id, currentUser.uid, record_id, data, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:367 ~ comm_removeRecord ~ error", e)
                    throw Error ('[comm_removeRecord] It is not possible connect to server.')
                }
        }
    }

    async function comm_removeRecord(token_id, currentUser, type, record_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_removeRecord(token_id, currentUser.uid, type, record_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:367 ~ comm_removeRecord ~ error", e)
                    throw Error ('[comm_removeRecord] It is not possible connect to server.')
                }
        }
    }

    async function comm_revertRemoveRecord(token_id, currentUser, type, record_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_revertRemoveRecord(token_id, currentUser.uid, type, record_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:386 ~ comm_revertRemoveRecord ~ error", e)
                    throw Error ('[comm_revertRemoveRecord] It is not possible connect to server.')
                }
        }
    }

    async function comm_updateDefaultPermission(token_id, currentUser, sw){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateDefaultPermission(token_id, currentUser.uid, sw, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:397 ~ comm_updateDefaultPermission ~ error", e)
                }
        }
    }

    async function comm_updateEmailPermission(token_id, currentUser, sw){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateEmailPermission(token_id, currentUser.uid, sw, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:113 ~ comm_updateTheme ~ error", e)
                }
        }
    }

    async function comm_updateDefaultCamera(token_id, currentUser, sw){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_updateDefaultCamera(token_id, currentUser.uid, sw, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:439 ~ comm_updateDefaultCamera ~ error", e)
                    // comm_updateTheme(token_id, currentUser, sw, commProviderSelectedIdx=pCommProviderSelection.SERVER_CLOUD)
                }
        }
    }

    async function comm_getDataVersusMachine(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDataVersusMachine(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:402 ~ comm_getDataVersusMachine ~ error", e)
                    throw Error ('[comm_getDataVersusMachine] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendResultsVersusMachine(token_id, currentUser, elements_response_send){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDataVersusMachine(token_id, currentUser.uid, elements_response_send, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:414 ~ comm_sendResultsVersusMachine ~ error", e)
                    throw Error ('[comm_sendResultsVersusMachine] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDataVersusMachine2(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDataVersusMachine2(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:402 ~ comm_getDataVersusMachine ~ error", e)
                    throw Error ('[comm_getDataVersusMachine] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendResultsVersusMachine2(token_id, currentUser, elements_response_send){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendDataVersusMachine2(token_id, currentUser.uid, elements_response_send, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:414 ~ comm_sendResultsVersusMachine ~ error", e)
                    throw Error ('[comm_sendResultsVersusMachine] It is not possible connect to server.')
                }
        }
    }

    async function comm_getDataMoveYourSkeleton(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getDataMoveYourSkeleton(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:402 ~ comm_getDataMoveYourSkeleton ~ error", e)
                    throw Error ('[comm_getDataMoveYourSkeleton] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendResultsMoveYourSkeleton(token_id, currentUser, elements_response_send){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendResultsMoveYourSkeleton(token_id, currentUser.uid, elements_response_send, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:414 ~ comm_sendResultsMoveYourSkeleton ~ error", e)
                    throw Error ('[comm_sendResultsMoveYourSkeleton] It is not possible connect to server.')
                }
        }
    }

    async function comm_sendVideoMoveYourSkeleton(token_id, currentUser, data, data_labels, f) {
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_sendVideoMoveYourSkeleton(token_id, currentUser.uid, data, data_labels, f, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:163 ~ comm_sendVideoMoveYourSkeleton ~ error", e)
                    throw Error ('[comm_sendVideoMoveYourSkeleton] It is not possible connect to server.')
                }
        }
    }


    async function comm_createTeam(token_id, currentUser, data){
        if (_check_user_data_is_registered(token_id, currentUser)){
            try{
                const response = await apiRest_createTeam(token_id, currentUser.uid, data, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:516 ~ comm_createTeam ~ error", e)
                throw Error ('[comm_createTeam] It is not possible connect to obtain this data.')
            }
        }
    }

    async function comm_getInfoTeam(token_id, currentUser, team_id){ 
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([team_id])){
                try{
                    const response = await apiRest_getInfoTeam(token_id, currentUser.uid, team_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:528 ~ comm_getInfoTeam ~ error", e)
                    throw Error ('[comm_getInfoTeam] It is not possible connect to obtain this data.')
                }
            }else{comm_updateTeam
                throw Error ('[comm_getInfoTeam] Field with undefined value.')
            }
        }
    }

    async function comm_removeTeam(token_id, currentUser, team_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([team_id])){
                try{
                    const response = await apiRest_removeTeam(token_id, currentUser.uid, team_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:540 ~ comm_removeTeam ~ error", e)
                    throw Error ('[comm_removeTeam] It is not possible connect to obtain this data.')
                }
            }else{comm_updateTeam
                throw Error ('[comm_removeTeam] Field with undefined value.')
            }
        }
    }

    async function comm_updateTeam(token_id, currentUser, team_id, data_in){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([team_id])){
                try{
                    const response = await apiRest_updateTeam(token_id, currentUser.uid, team_id, data_in, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:561 ~ comm_updateTeam ~ error", e)
                    throw Error ('[comm_updateTeam] It is not possible connect to obtain this data.')
                }
            }else{comm_updateTeam
                throw Error ('[comm_getTaskTeam] Field with undefined value.')
            }
        }
    }


    async function comm_acceptInvitationMemberTeam(token_id, currentUser, team_id, target_user_id = null){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([team_id])){
                try{
                    const response = await apiRest_acceptInvitationMemberTeam(token_id, currentUser.uid, team_id, target_user_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:578 ~ comm_acceptInvitationMemberTeam ~ error", e)
                    throw Error ('[comm_acceptInvitationMemberTeam] It is not possible connect to obtain this data.')
                }
            }else{
                throw Error ('[comm_acceptInvitationMemberTeam] Field with undefined value.')
            }
        }
    }


    async function comm_requestInvitationMemberTeam(token_id, currentUser, team_id, target_user_id = null){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([team_id])){
                try{
                    const response = await apiRest_requestInvitationMemberTeam(token_id, currentUser.uid, team_id, target_user_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:578 ~ comm_requestInvitationMemberTeam ~ error", e)
                    throw Error ('[comm_requestInvitationMemberTeam] It is not possible connect to obtain this data.')
                }
            }else{
                throw Error ('[comm_requestInvitationMemberTeam] Field with undefined value.')
            }
        }
    }


    async function comm_getInfoMemberTeam(token_id, currentUser){ 
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getInfoMemberTeam(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:587 ~ comm_getInfoMemberTeam ~ error", e)
                    throw Error ('[comm_getInfoMemberTeam] It is not possible connect to obtain this data.')
                }
        }
    }

    async function comm_cancelInvitationMemberTeam(token_id, currentUser, target_team_id, target_user_id = null){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([target_team_id])){
                try{
                    const response = await apiRest_cancelInvitationMemberTeam(token_id, currentUser.uid, target_team_id, target_user_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:604 ~ comm_cancelInvitationMemberTeam ~ error", e)
                    throw Error ('[comm_cancelInvitationMemberTeam] It is not possible connect to obtain this data.')
                }
            }else{
                throw Error ('[comm_cancelInvitationMemberTeam] Field with undefined value.')
            }
        }
    }





    // RANKING-TEAM 
    async function comm_getRankDataTeam(token_id, currentUser){ 
        if (_check_user_data_is_registered(token_id, currentUser)){
            try{
                const response = await apiRest_getRankDataTeam(token_id, currentUser.uid, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:629 ~ comm_getRankDataTeam ~ error", e)
                throw Error ('[comm_getRankDataTeam] It is not possible connect to obtain this data.')
            }
        }
    }


    // TASK-TEAM
    async function comm_createTaskTeam(token_id, currentUser, data){
        if (_check_user_data_is_registered(token_id, currentUser)){
            try{
                const response = await apiRest_createTaskTeam(token_id, currentUser.uid, data, base_url)
                return response
            }catch(e){
                console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:642 ~ comm_createTaskTeam ~ error", e)
                throw Error ('[comm_createTaskTeam] It is not possible connect to obtain this data.')
            }
        }
    }

    async function comm_getTaskTeam(token_id, currentUser, target_team_id, target_task_id, target_user_id ){ 
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([target_team_id, target_user_id])){
                try{
                    if (target_team_id === undefined || target_user_id === undefined){
                        throw Error ('[comm_getTaskTeam] Field with undefined value.')
                    }else{
                        const response = await apiRest_getTaskTeam(token_id, currentUser.uid, target_team_id, target_task_id, target_user_id, base_url)
                        return response
                    }
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:654 ~ comm_getTaskTeam ~ error", e)
                    throw Error ('[comm_getTaskTeam] It is not possible connect to obtain this data.')
                }
            }else{
                throw Error ('[comm_getTaskTeam] Field with undefined value.')
            }
        }
    }

    async function comm_removeTaskTeam(token_id, currentUser, target_team_id, target_task_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([target_team_id, target_task_id])){
                try{
                    const response = await apiRest_removeTaskTeam(token_id, currentUser.uid, target_team_id, target_task_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:700 ~ comm_removeTaskTeam ~ error", e)
                    throw Error ('[comm_removeTaskTeam] It is not possible connect to obtain this data.')
                }
            }else{
                throw Error ('[comm_removeTaskTeam] Field with undefined value.')
            }
        }
    }

    async function comm_updateTaskTeam(token_id, currentUser, target_task_id, data_in){
        if (_check_user_data_is_registered(token_id, currentUser)){
            if (_check_data_is_not_undefined([target_task_id])){
                try{
                    const response = await apiRest_updateTaskTeam(token_id, currentUser.uid, target_task_id, data_in, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:716 ~ comm_updateTaskTeam ~ error", e)
                    throw Error ('[comm_updateTaskTeam] It is not possible connect to obtain this data.')
                }
            }else {
                throw Error ('[comm_updateTaskTeam] Field with undefined value.')
            }
        }
    }


    async function comm_sendResponseSurvey(token_id, currentUser, data_response){
        try{
            const response = await apiRest_sendResponseSurvey(token_id, currentUser.uid, data_response, base_url)
            return response
        }catch(e){
            console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:811 ~ comm_sendResponseSurvey ~ error", e)
            throw Error ('[comm_sendResponseSurvey] It is not possible connect to obtain this data.')
        }
    }




    
    async function comm_getMessage(){
        throw Error ('[comm_getMessage] Not implemented yet.')
    }

    async function comm_createMessage(){
        throw Error ('[comm_createMessage] Not implemented yet.')
    }

    async function comm_removeMessage(){
        throw Error ('[comm_removeMessage] Not implemented yet.')
    }

    async function comm_sendForm(){   // PENDIENTE DE DEFINIR BIEN TANTO EN LOS DIAGRAMAS, COMO PREPRAR LA BBDD, MENSAJES DE ENTRADA --- PROPORCIONAR JSON? ES POST - USAR FORMDATA.
        throw Error ('[comm_sendForm] Not implemented yet.')
    }


    async function comm_getReportActivity(token_id, currentUser, type, target){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getReportActivity(token_id, currentUser.uid, type, target, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:754 ~ apiRest_getReportActivity ~ error", e)
                    throw Error ('[comm_getReportUserActivity] It is not possible connect to server.')
                }
        }
    }


    async function comm_getReportUserActivity(token_id, currentUser){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getReportUserActivity(token_id, currentUser.uid, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:754 ~ comm_getReportUserActivity ~ error", e)
                    throw Error ('[comm_getReportUserActivity] It is not possible connect to server.')
                }
        }
    }

    async function comm_getReportTeamActivity(token_id, currentUser, team_id){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getReportTeamActivity(token_id, currentUser.uid, team_id, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:754 ~ comm_getReportTeamActivity ~ error", e)
                    throw Error ('[comm_getReportTeamActivity] It is not possible connect to server.')
                }
        }
    }



    async function comm_getLeaderboard(token_id, currentUser, type, scope){
        if (_check_user_data_is_registered(token_id, currentUser)){
                try{
                    const response = await apiRest_getLeaderboard(token_id, currentUser.uid, type, scope, base_url)
                    return response
                }catch(e){
                    console.error("[SERVER - ERROR] 🚀 ~ file: CommProvider.js:754 ~ comm_getLeaderboard ~ error", e)
                    throw Error ('[comm_getLeaderboard] It is not possible connect to server.')
                }
        }
    }







    // AUTHENTICATION FUNCTIONS
    function comm_login(email, password) {
        return firebase_login(firebase_auth, email, password);
    }
    function comm_login_google_provider() {
        return firebase_login_google_provider(firebase_auth, googleProvider);
    }
    function comm_signup(email, password) {
        return firebase_signup(firebase_auth, email, password);
    }
    function comm_logout() {
        return firebase_logout(firebase_auth);
    }
    function comm_resetPassword(email) {
        return firebase_resetPassword(firebase_auth, email);
    }
    function comm_guestLogin() {
        return firebase_guestLogin(firebase_auth);
    }


    // PRIVATE AUX FUNCTIONS
    function _check_user_data_is_registered(token_id, currentUser){
        try{
            return (token_id === null || currentUser.isAnonymous) ? false : true
        }catch(e){
            throw Error ('[check_is_current_users_token_valid] Current user or token not valid')
        }
    }

    function _check_data_is_not_undefined(arr_fields_data){
        return (arr_fields_data.includes(undefined)) ? false : true
    }
 

    const value = {
        commProviderSelected,
        base_url_data,
        comm_downloadFileFromUrl, 

        // GLOBAL
        comm_configure_base_url,
        comm_activateListenerUserAuth,  
        comm_updateUserTokenAuth,          // Firebase
        comm_getJSONData,               // Server & Firebase
        comm_getJSONWebInfo,            // Server & Firebase
        comm_getVideoData,              // Server

        // AUTHENTICATION FUNCTIONS
        comm_login,                     // Firebase
        comm_login_google_provider,     // Firebase
        comm_signup,                    // Firebase
        comm_logout,                    // Firebase
        comm_resetPassword,             // Firebase
        comm_guestLogin,                // Firebase
        
        // FUNTIONS
        // SEARCH_BY_VIDEO
        comm_sendVideo,                 // Server
        comm_sendMediapipe,             // Server
        comm_sendMediapipeFastMode,     // Server  
        comm_sendVideoFS,
 
        // COLLABORATION
        comm_sendCollaboration,         // Server
        comm_sendSubmission,
        commm_updateFeedback,           // Server

        comm_sendDonateFingerspelling,         // Server
        comm_getDonateFingerspelling,         // Server
       

        // USER
        comm_getJSONDataUser,           // Server & Firebase
        comm_updateProfile,             // Server
        comm_updateTheme,               // Server
        comm_updateLang,               // Server
        comm_updateSession,               // Server

        comm_addFavorites,              // Server
        comm_removeFavorites,           // Server
        comm_getHistory,                // Server
        comm_addHistory,                // Server
        comm_removeHistory,             // Server
        comm_getRecords,                 // Server
        // comm_addRecord,                 // Server
        updateFeedbackRecord,              // Server
        comm_removeRecord,              // Server
        comm_revertRemoveRecord,        // Server
        comm_updateDefaultPermission,   // Server
        comm_updateEmailPermission,
        comm_updateDefaultCamera,       
        comm_getMessage,                // Server & Firebase
        comm_createMessage,             // Server
        comm_removeMessage,             // Server


        comm_getReportActivity,
        comm_getReportUserActivity,     // Server
        comm_getReportTeamActivity,     // Server

        // DATASETBUILDER
        comm_getDatasetBuilder,
        comm_requestVideoDatasetBuilder,    // Server
        comm_sendDatasetBuilder,            // Server


        comm_getDatasetBuilderSentence,
        comm_sendDatasetBuilderSentence,
        comm_deleteDatasetBuilderSentence,

        // DONATESIGN
        comm_getDonateSign,
        comm_sendDonateSign,

        // VERSUSMACHINE
        comm_getDataVersusMachine, 
        comm_sendResultsVersusMachine,
        comm_getDataVersusMachine2, 
        comm_sendResultsVersusMachine2,

        // MOVE_YOUR_SKELETON
        comm_getDataMoveYourSkeleton,
        comm_sendResultsMoveYourSkeleton,
        comm_sendVideoMoveYourSkeleton,

        // REPORTBUG
        comm_createReportBug,           // Server
        comm_getReportBug,              // Server
        comm_updateReportBug,           // Server
        comm_closeReportBug,             // Server


        // ManageTeams
        comm_createTeam,        
        comm_getInfoTeam,
        comm_removeTeam,
        comm_updateTeam,

        comm_acceptInvitationMemberTeam,
        comm_requestInvitationMemberTeam,
        comm_cancelInvitationMemberTeam,
        comm_getInfoMemberTeam,

        comm_getRankDataTeam,

        comm_createTaskTeam,
        comm_getTaskTeam,
        comm_updateTaskTeam,
        comm_removeTaskTeam,

        comm_getLeaderboard,

        comm_donateSentence,
        comm_getDonateSentence,
        comm_donateResponse,
        comm_getDonateResponse,

        comm_sendResponseSurvey,

        // FORM
        comm_sendForm,                  // Firebase
    };
    
    return <CommProviderContext.Provider value={value}>{children}</CommProviderContext.Provider>;
}
